(function () {
    const query    = (selector, ctx = document) => ctx.querySelector(selector);
    const queryAll = (selector, ctx = document) => ctx.querySelectorAll(selector);

    const reset_password_modal  = query('#jss_reset_password_modal');
    const reset_password_form   = query('form[name=reset_password_form]', reset_password_modal);
    const success_message       = query('.jss_reset_done', reset_password_form);
    const form_inputs_container = query('.jss_form_inputs_container', reset_password_form);
    const form_inputs           = queryAll('input', form_inputs_container);
    const submit_btn            = query('button[type=submit]', reset_password_modal);
    const submit_spinner        = query('i.fa-spinner', submit_btn);

    const url = "/apps/ChangePassword";
    const possible_errors = [
        "illegal_identifier",
        "illegal_email",
        "invalid_combination",
        "technical_problem"
    ];

    const handle_success = () => {
        success_message.classList.remove('d-none');
        form_inputs_container.classList.add('d-none');
        submit_btn.classList.add('d-none');
    };

    const show_error = (error) => {
        query(`.jss_error_${error}`).classList.remove('d-none');
        if (error === "illegal_identifier" || error === "illegal_email") {
            query(`input[data-error-name=${error}]`, form_inputs_container).classList.add('is-invalid');
        }
    };

    const hide_error = (error) => {
        query(error, reset_password_form).classList.add('d-none');
    };

    const show_default = (e) => {
        e.target.classList.remove('is-invalid');
        possible_errors.forEach(error => {
            hide_error(`.jss_error_${error}`);
        });
    };

    const handle_failed = (data) => {
        possible_errors.forEach(error => {
            if (data[error]) {
                show_error(error);
            }
        });
    };

    const show_spinner = () => {
        submit_btn.disabled = true;
        submit_spinner.classList.remove('d-none');
    };

    const hide_spinner = () => {
        submit_btn.disabled = false;
        submit_spinner.classList.add('d-none');
    };

    const send_form = async () => {
        let form_data = new FormData();

        form_data.append('change_password_json', 1);
        form_inputs.forEach(input => {
            form_data.append(input.name, input.value.trim() );
        });

        await fetch(url, {
            method: "POST",
            body: form_data
        })
            .then(res => res.json())
            .then(data => {
                hide_spinner();
                if (data.success) {
                    handle_success();
                } else {
                    handle_failed(data);
                }
            });
    };

    const handle_send_form = (e) => {
        e.preventDefault();
        show_spinner();

        send_form();
    };

    reset_password_form.addEventListener('submit', handle_send_form);
    form_inputs.forEach(input => {
        input.addEventListener('input', show_default);
    });

})();
